// extracted by mini-css-extract-plugin
export default {"title":"Title__title___PKi8B","normal":"Title__normal___LPe9z","small":"Title__small___MExi0"};